import React, { useRef } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';

import { useAppState } from "core/contexts/AppContext";
import { retrieveValue } from "core/includes/localStorage";
import { PUBLIC_KEYS_FOR_SHOP_2, publicKeys } from "core/config/stripeConfig";
import { hasFeatureFlag } from "core/includes/site";
import { FLAG_SHOP_2 } from "core/includes/featureFlags";
import useCart from "pages/Components/CartPage/hooks/useCart";

type Props = {
    children?: React.ReactNode,
};

const StripeLoader: React.FC<Props> = ({ children }) => {
    const stripeKey = useRef('none');
    const [appState] = useAppState();
    const { getCountry } = useCart();
    const cartCountryCode = getCountry();

    const hasShopFeatureFlag = hasFeatureFlag(appState.featureFlags, FLAG_SHOP_2);
    const countryCodeSelected = hasShopFeatureFlag ?
        cartCountryCode.code.toLowerCase() :
        retrieveValue('selected-country')?.replace(/"/g, "") || appState.countryCode?.code.toLowerCase();

    if (hasShopFeatureFlag) {
        stripeKey.current = (
            PUBLIC_KEYS_FOR_SHOP_2.find(keySet => keySet.country === countryCodeSelected)?.key ??
            PUBLIC_KEYS_FOR_SHOP_2.find(keySet => keySet.country === 'default')?.key
        ) || '';
    } else {
        stripeKey.current = (
            publicKeys.find(keySet => keySet.country === countryCodeSelected)?.key ??
            publicKeys.find(keySet => keySet.country === 'default')?.key
        ) || '';
    }

    const stripePromise: any = loadStripe(stripeKey.current);

    if (!stripePromise) {
        return <div />;
    }

    return (
        // key is necessary to ensure Stripe updates country on country change.
        <Elements key={stripeKey.current} stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default StripeLoader;
